// constants.js
export const DEFAULT_LOGO_URL = "https://assets.talview.com/images/talview_grey.png";
